goog.provide("shadow.js.shim.module$src$svg$editor$emoji$heart_svg");
goog.provide("module$shadow_js_shim_module$src$svg$editor$emoji$heart_svg");
shadow.js.shim.module$src$svg$editor$emoji$heart_svg = shadow.js.nativeProvides["src/svg/editor/emoji/heart.svg"] = shadow$bridge("src/svg/editor/emoji/heart.svg");
module$shadow_js_shim_module$src$svg$editor$emoji$heart_svg.default = shadow.js.shim.module$src$svg$editor$emoji$heart_svg;
